import { CustomOperatorPolicies, CustomOperatorPoliciesIDs } from '@ibk/shared-types';
export const RestrictedPoliciesRelationship = {
    [CustomOperatorPoliciesIDs.ACCOUNT_MANAGER]: [
        CustomOperatorPolicies.ACCOUNT_MANAGER,
        CustomOperatorPolicies.INSTRUCTION_OPERATOR,
        CustomOperatorPolicies.ACCOUNT_PAYABLES_MANAGER,
    ],
    [CustomOperatorPoliciesIDs.TRANSACTION_LIMIT]: [CustomOperatorPolicies.TRANSACTION_LIMIT],
    [CustomOperatorPoliciesIDs.BENEFITS_MANAGER]: [CustomOperatorPolicies.BENEFITS_MANAGER],
    [CustomOperatorPoliciesIDs.BILLING_MANAGER]: [CustomOperatorPolicies.BILLING_MANAGER],
    [CustomOperatorPoliciesIDs.NFSE_MANAGER]: [CustomOperatorPolicies.NFSE_MANAGER],
};
